import { isMobile } from "react-device-detect";

export function checkLength(title, number, inAll) {
  if (title.length > number && (inAll || isMobile)) {
    var newTitle = title.slice(0, number);
    return newTitle + " ...";
  } else {
    return title;
  }
}

export default checkLength;
